import { Button } from '@any-ui-react/core';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Card } from '../card';
import { MaterialIcons } from '../material-icons';

export interface ErrorCardProps {
  title: string;
  guideline?: ReactNode;
  note?: string;
  buttonLink?: string;
  buttonText?: string;
  iconColor?: string;
  className?: string;
  children?: ReactNode;
}

export const ErrorCard = ({
  title,
  guideline,
  note,
  buttonLink,
  buttonText,
  iconColor = 'text-warning',
  className,
  children,
}: ErrorCardProps) => (
  <Card className={classNames('flex flex-col items-center gap-y-4 max-w-lg mx-auto mt-10', className)}>
    <MaterialIcons iconName="warning" fill={true} className={iconColor} fontSize="20px" />
    <h2 className="font-semibold">{title}</h2>
    {guideline && <div className="text-center">{guideline}</div>}
    {note && <small className="font-semibold">{note}</small>}
    {buttonLink && buttonText && (
      <Link to={buttonLink}>
        <Button className="bg-blue-6" type="submit">
          {buttonText}
        </Button>
      </Link>
    )}
    {children}
  </Card>
);
